// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"6cacaad5d7da2c0ea30f","655":"b081409541947da1bb8e"}[chunkId] + ".js";
};